import {ApiError} from '../../../../../util/error';

export function facebookValidationError(error: unknown): Array<string> | boolean {
    if (error instanceof ApiError && typeof error.jsonData === 'object' && error.jsonData) {
        return Object.entries(error.jsonData).map(([_key, value]) => value);
    }

    return false;
}
